package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.di.getKoinInstance
import com.eladfinish.bible.contest.interesting_fact1
import com.eladfinish.bible.contest.interesting_fact10
import com.eladfinish.bible.contest.interesting_fact11
import com.eladfinish.bible.contest.interesting_fact12
import com.eladfinish.bible.contest.interesting_fact2
import com.eladfinish.bible.contest.interesting_fact3
import com.eladfinish.bible.contest.interesting_fact4
import com.eladfinish.bible.contest.interesting_fact5
import com.eladfinish.bible.contest.interesting_fact5a
import com.eladfinish.bible.contest.interesting_fact5b
import com.eladfinish.bible.contest.interesting_fact6
import com.eladfinish.bible.contest.interesting_fact7
import com.eladfinish.bible.contest.interesting_fact8
import com.eladfinish.bible.contest.interesting_fact9
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.ConsecutiveVersesWithSameNumberOfLetters
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.ContainsAllHebrewLetters
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.GematriaCalculator
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.HebrewLetterSearchMode
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.IdenticalWordsReyshaLastAndSeyfaFirst
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.LexicographicOrder
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.SearchFact
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.VersesPerAliyot
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.VersesPerChapters
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.VersesStatisticsType
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.WordCounter
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.WordIndex
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.WordsPerParashot
import dev.icerock.moko.resources.desc.Resource
import dev.icerock.moko.resources.desc.StringDesc

class GetSearchFactsUseCase {

    operator fun invoke(): List<SearchFact> =
        listOf(
            SearchFact(
                searchProvider = { WordCounter() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact4),
            ),
            SearchFact(
                searchProvider = { GematriaCalculator() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact2),
            ),
            SearchFact(
                searchProvider = { ConsecutiveVersesWithSameNumberOfLetters() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact1),
            ),
            SearchFact(
                searchProvider = { getKoinInstance<VersesPerAliyot>(VersesStatisticsType.PER_ALIYOT) },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact5),
            ),
            SearchFact(
                searchProvider = { getKoinInstance<VersesPerAliyot>(VersesStatisticsType.TOTAL_ASCENDING_ORDER) },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact5a),
            ),
            SearchFact(
                searchProvider = { getKoinInstance<VersesPerAliyot>(VersesStatisticsType.TOTAL_DESCENDING_ORDER) },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact5b),
            ),
            SearchFact(
                searchProvider = { getKoinInstance<WordsPerParashot>() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact12),
            ),
            SearchFact(
                searchProvider = { VersesPerChapters() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact6),
            ),
            SearchFact(
                searchProvider = {
                    IdenticalWordsReyshaLastAndSeyfaFirst(
                        partitionChapterUseCase = getKoinInstance(),
                    )
                },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact7),
            ),
            SearchFact(
                searchProvider = { WordIndex() },
                stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact8),
                shouldShowAsList = true,
            ),
            *HebrewLetterSearchMode.entries
                .sortedBy { it.priority }
                .map { mode ->
                    SearchFact(
                        searchProvider = { ContainsAllHebrewLetters(mode) },
                        stringDesc = when (mode) {
                            HebrewLetterSearchMode.BASE_OR_FINAL_EQUIVALENT ->
                                StringDesc.Resource(SharedRes.strings.interesting_fact9)


                            HebrewLetterSearchMode.BASE_ONLY ->
                                StringDesc.Resource(SharedRes.strings.interesting_fact10)

                            HebrewLetterSearchMode.BASE_AND_FINAL_REQUIRED ->
                                StringDesc.Resource(SharedRes.strings.interesting_fact11)
                        },
                    )
                }.toTypedArray(),
            *LexicographicOrder.LexicoType.entries.map { lexicoType: LexicographicOrder.LexicoType ->
                SearchFact(
                    searchProvider = { LexicographicOrder(lexicoType = lexicoType) },
                    stringDesc = StringDesc.Resource(SharedRes.strings.interesting_fact3),
                    extraData = lexicoType.inequalityDescription(),
                )
            }.toTypedArray(),
        )

}
